let $toggles = Array.from(document.querySelectorAll('.js-toggle'))

$toggles.forEach(init)

function init ($toggle) {
  $toggle.addEventListener('click', toggle)
}

function toggle (e) {
  e.preventDefault()

  let $toggle = e.target.closest('.js-toggle')
  let targetId = $toggle.getAttribute('aria-controls')

  let $target = targetId
    ? document.getElementById(targetId)
    : $toggle.nextElementSibling

  $target.hidden = !$target.hidden

  $toggle.setAttribute('aria-expanded', $target.hidden ? 'false' : 'true')

  if (!$target.hidden) {
    let $focusable = $target.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    if ($focusable) $focusable.focus()
  }
}



// WEBPACK FOOTER //
// ./src/js/_toggle.js